import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter as Router } from "react-router-dom";
import { BaseAppContext } from "./utils/context";
import { LSK_AUTH_TOKEN } from "./utils/LocalStorageUtil";
import Layout from "./pages/layout/layout";
import React, { useEffect, useState, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  const [authState, setAuthState] = useState({
    auth: "",
    isLoggedIn: false,
    loggedUserId: "",
    loggedUserName: "",
    loggedUserRole: 0,
    loggedPatientId: "",
  });

  const setContext = useCallback((data: Partial<typeof authState>) => {
    setAuthState((prev) => ({ ...prev, ...data }));
  }, []);

  const clearContext = useCallback(() => {
    setAuthState({
      auth: "",
      isLoggedIn: false,
      loggedUserId: "",
      loggedUserName: "",
      loggedUserRole: 0,
      loggedPatientId: "",
    });
  }, []);

  useEffect(() => {
    const token = localStorage.getItem(LSK_AUTH_TOKEN);
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split(".")[1]));
        const user = JSON.parse(payload.sub);
        setAuthState({
          auth: token,
          isLoggedIn: true,
          loggedUserId: user.userId || "",
          loggedUserName: user.username || "",
          loggedUserRole: user.roleId || 0,
          loggedPatientId: user.patientId || "",
        });
      } catch (error) {
        console.error("Invalid JWT Token", error);
      }
    }
  }, []);

  return (
    <BaseAppContext.Provider value={{ ...authState, setContext, clearContext }}>
      <Router>
        <Layout>
          <AppRoutes />
        </Layout>
        <ToastContainer position="top-right" autoClose={3000} />
      </Router>
    </BaseAppContext.Provider>
  );
}

export default App;
